import React from 'react';
import './style.scss';
import LogoListingCard from '../card';
import CarouselSlider from '../../../Shared/components/Carousel/shared/slider';
import { SwiperSlide } from 'swiper/react/swiper-react.js';

const LogoListingCarousel = ({ items, mobile, limit }) => {
  const filtered = mobile && limit > 1 && items.length > limit ? items.slice(0, limit) : items;

  return (
    <div className="ll-carousel-wrapper">
      <CarouselSlider
        slidesPerView={'auto'}
        lang="en"
        bulletClassName="carousel-bullet carousel-bullet-light"
      >
        {filtered.map((item, index) => (
          <SwiperSlide key={index} className="ll-carousel-slide">
            <LogoListingCard data={item} key={index} />
          </SwiperSlide>
        ))}
      </CarouselSlider>
    </div>
  );
};

export default LogoListingCarousel;
